import type { OrganizationCreate } from '../../../../utils/types/admin_types';
import type { ILicenseCatalogItem, LicenseCatalogKey } from '../interfaces';

export const COMPANY_SIZE_OPTIONS: { label: string; value: OrganizationCreate['company_size'] }[] = [
  { label: 'Small', value: 'Small' },
  { label: 'Medium', value: 'Medium' },
  { label: 'Large', value: 'Large' },
  { label: 'Large Enterprise', value: 'Large Enterprise' },
];

export const CREATE_LICENSE_KEY_MAP: Record<string, LicenseCatalogKey> = {
  hierTalentBase: 'hierTalentBase',
  autoAssessments: 'hierTalentAutoAssessments',
  autoClassify: 'hierTalentAutoClassify',
  jobPost: 'hierTalentJobPost',
  smartInterviews: 'hierTalentSmartInterviews',
  candiBank: 'hierTalentCandiBank',
  psychometricFaxtor: 'hierTalentPsychometricFaxtor',
  wellness: 'hierTalentWellness',
};

export const CREATE_LICENSE_CATALOG: ILicenseCatalogItem[] = [
  {
    id: 'hierTalentBase',
    licenseKey: 'hierTalentBase',
    label: 'HierTalent Base',
    iconPath: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10',
    iconClassName: 'bg-emerald-50 text-emerald-600',
  },
  {
    id: 'autoAssessments',
    licenseKey: 'hierTalentAutoAssessments',
    label: 'Auto Assessments',
    iconPath: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
    iconClassName: 'bg-blue-50 text-blue-600',
  },
  {
    id: 'autoClassify',
    licenseKey: 'hierTalentAutoClassify',
    label: 'Auto Classify',
    iconPath: 'M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z',
    iconClassName: 'bg-indigo-50 text-indigo-600',
  },
  {
    id: 'jobPost',
    licenseKey: 'hierTalentJobPost',
    label: 'Job Post',
    iconPath: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
    iconClassName: 'bg-amber-50 text-amber-600',
  },
  {
    id: 'smartInterviews',
    licenseKey: 'hierTalentSmartInterviews',
    label: 'Smart Interviews',
    iconPath: 'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z',
    iconClassName: 'bg-rose-50 text-rose-600',
  },
  {
    id: 'candiBank',
    licenseKey: 'hierTalentCandiBank',
    label: 'CandiBank',
    iconPath: 'M8 14v20M24 14v20M8 24h16',
    iconClassName: 'bg-slate-900 text-white',
    isSpecialIcon: true,
    creditUnit: 'CVs',
  },
  {
    id: 'psychometricFaxtor',
    licenseKey: 'hierTalentPsychometricFaxtor',
    label: 'Psychometric Faxtor',
    iconPath: 'M9.5 2a4.5 4.5 0 00-4.5 4.5v.5a4 4 0 00-2 3.5 4 4 0 002 3.5v1a4.5 4.5 0 004.5 4.5h.5M14.5 2a4.5 4.5 0 014.5 4.5v.5a4 4 0 012 3.5 4 4 0 01-2 3.5v1a4.5 4.5 0 01-4.5 4.5h-.5M9.5 2v18M14.5 2v18',
    iconClassName: 'bg-violet-50 text-violet-600',
  },
  {
    id: 'wellness',
    licenseKey: 'hierTalentWellness',
    label: 'Wellness',
    iconPath: 'M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 10-7.78 7.78l1.06 1.06L12 21l7.78-7.55 1.06-1.06a5.5 5.5 0 000-7.78z',
    iconClassName: 'bg-teal-50 text-teal-600',
  },
];

export const CREATE_DISABLED_TOOLTIP_INCOMPLETE =
  'Please fill in all organization and administrator details.';

export const CREATE_DISABLED_TOOLTIP_LICENSES =
  'Fill in start & end dates for all active licenses.';
